var React = require('react');

function Hammer (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M422.4 25.6h-51.2c-14.14 0-25.6 11.46-25.6 25.6h-38.4V25.6c0-14.14-11.46-25.6-25.6-25.6h-51.2c-14.14 0-25.6 11.46-25.6 25.6 0 9.062-.171 17.587-.35 26.069C136.9 56.422 64 98.381 64 204.8c0 11.87 8.166 22.187 19.721 24.917a25.73 25.73 0 005.888.691c9.523 0 18.483-5.342 22.886-14.157 13.85-27.691 53.734-34.679 81.946-36.446-6.554 44.578-13.815 67.755-13.952 68.156a26.24 26.24 0 00-1.289 8.038v230.4c0 14.14 11.46 25.6 25.6 25.6h76.8c14.14 0 25.6-11.46 25.6-25.6V179.2h38.4c0 14.14 11.46 25.6 25.6 25.6h51.2c14.14 0 25.6-11.46 25.6-25.6v-128c0-14.14-11.46-25.6-25.6-25.6zm-192 0h51.2v25.6h-51.533c.171-8.346.333-16.717.333-25.6zm51.2 460.8h-76.8V256s8.457-25.89 15.659-76.8H281.6v307.2zm140.8-307.2h-51.2v-25.6H217.6c-25.6 0-102.4 0-128 51.2 0-102.4 76.8-128 128-128h153.6V51.2h51.2v128z"}));
}

Hammer.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Hammer;

Hammer.default = Hammer;
